export function getFontAwesomeIconFromMimeType(mimeType: string) {
  switch (mimeType) {
    case 'application/msword':
    case 'application/rtf':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return 'file-doc';

    case 'application/pdf':
      return 'file-pdf';

    case 'application/postscript':
      return 'file-eps';

    case 'application/vnd.ms-excel':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return 'file-xls';

    case 'application/vnd.ms-outlook':
    case 'message/rfc822':
      return 'envelope';

    case 'image/bmp':
    case 'image/gif':
    case 'image/jpeg':
    case 'image/png':
      return 'image';

    default:
      return 'file';
  }
}
